/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import iconPremiumInverse from "components/shared/premium-inverse.svg";

export const PremiumIcon = styled.img.attrs({
  src: iconPremiumInverse,
  alt: I18n.t("icons.premium_icon.alt"),
})<{ size?: number }>`
  width: ${({ size }): number => size ?? 30}px;
  height: ${({ size }): number => size ?? 30}px;
`;

export const PremiumButtonIcon = styled.img.attrs({
  src: iconPremiumInverse,
  slot: "icon",
  alt: I18n.t("icons.premium_icon.alt"),
})``;
